var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"mt-5",style:({backgroundColor: _vm.slider[_vm.id].color})},[_c('div',{staticClass:"slider slider__text"},[_vm._v(_vm._s(_vm.$t(_vm.slider[_vm.id].text)))]),_c('div',{staticClass:"d-flex align-center"},[_c('div',{staticClass:"slider slider__author"},[_vm._v(_vm._s(_vm.$t(_vm.slider[_vm.id].author)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }